var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fields-list',{attrs:{"fields":_vm.fields,"item":_vm.item,"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }